export const MAX_COLLATERAL_P = 30